module.exports = __webpack_public_path__ + "static/media/NvphFoundation.6bd624da.webp";